import { UIKitIcon } from '../icon';

export const chevronRightIcon: UIKitIcon = {
  name: 'chevronRight',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g transform="translate(32 32) rotate(180)">'
  + '<path d="M1759.661-263.339,1754-269l5.661-5.661" transform="translate(-1741 285.161)" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></g></svg>',
};
